import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../api";
import InvitationCard from "./InvitationTemplates";
import { motion } from "framer-motion";
import RSVPForm from "./RSVPForm";

const InvitationView = () => {
  const { eventId } = useParams();
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEvent = async () => {
      try {
        const res = await api.get(`/api/events/${eventId}`);
        setEvent(res.data);
      } catch (err) {
        console.error("Fetch event error:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchEvent();
  }, [eventId]);

  if (loading) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center bg-surface-variant">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!event) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center bg-surface-variant text-center p-4" dir="rtl">
        <div className="card shadow-lg p-5 rounded-celebration border-0 maxWidth-600">
          <h2 className="fw-black mb-3 text-primary" style={{ fontFamily: 'var(--font-headline)' }}>عفواً، لم يتم العثور على المناسبة</h2>
          <p className="text-on-surface-variant arabic-leading">الرابط ده مش مظبوط أو المناسبة اتمسحت.</p>
        </div>
      </div>
    );
  }

  const qrUrl = process.env.REACT_APP_CLIENT_URL + `/event/${event._id || event.id}`;

  return (
    <div className="invitation-page min-vh-100 bg-surface-variant py-0 py-md-5 d-flex justify-content-center align-items-start">
      <motion.div
        className="invitation-container shadow-2xl overflow-hidden bg-white rounded-celebration border border-primary-dim"
        style={{ width: '100%', maxWidth: '500px' }}
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
      >
        <InvitationCard
          event={event}
          templateId={event.settings?.cardTemplate || "classic"}
          qrUrl={qrUrl}
        />

        <div className="d-print-none text-center p-4 bg-surface-variant border-top border-primary-dim">
          {event.rsvpEnabled && (
            <div className="mb-5">
              <RSVPForm eventId={eventId} />
            </div>
          )}

          <button className="btn btn-primary fw-bold px-5 py-3 rounded-pill shadow-lg" onClick={() => window.print()}>
            🖨️ طباعة أو حفظ كـ PDF
          </button>
          <p className="small text-on-surface-variant mt-3 mb-0 arabic-leading fw-medium">
            تقدر كمان تاخد لقطة شاشة (Screenshot) وتبعته للضيوف على الواتساب.
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default InvitationView;
